import { useRef } from 'react';
import { Header } from '../../common/Header/Header.jsx';
import { ActionButton } from '../../common/Buttons/Buttons.jsx';
import { FilterDatePicker, SearchInput, SelectPerPage } from '../../common/Forms/Input/Input.jsx';
import { PotentialClientsTable } from '../../common/Tables/Tables';
import { particularClientsTableHeader } from '../../../assets/helpers/tables';
import { usePotentialClients } from '../../../hooks/usePotentialClients';
import './PotentialClients.scss';

export const ParticularPotentialClients = () => {
  const tableRef = useRef(null);

  const {
    converteRate,
    membershipsDatatable,
    dateFrom,
    dateTo,
    channels,
    serviceTypes,
    canSeeDates,
    canSeePerPage,
    itemsPerpage,
    handleSinceDateChange,
    handleUntilDateChange,
    selectitemsPerpage,
    handlePageChange,
    handleSearchChange,
    clearFilters,
    handleChannelOptions,
    handleServiceTypeOptions,
    handleAffiliatedOptions,
    getMemberships,
  } = usePotentialClients({ fixedType: 'Particular' });

  return (
    <>
      <Header />
      <div className="service-with-container container">
        <div className="d-flex flex-column align-items-start mb-4">
          <h1 className="title-component">Clientes Potenciales — Particulares</h1>
          {converteRate && (
            <h5 className="subtitle-component">
              Porcentaje de Conversion: {converteRate}%
            </h5>
          )}
        </div>

        <div className="breadcrumb-container">
          <div className="exportables-buttons-container">
            <div className="filters-row">
              <div className="filters-row__search">
                <SearchInput
                  placeholder="Nombre o Apellido, Teléfono, Cédula, Referencia o Placa"
                  searchAction={getMemberships}
                  value={membershipsDatatable.searchParam}
                  onChange={handleSearchChange}
                />
              </div>

              {canSeeDates && (
                <div className="filters-row__dates">
                  <FilterDatePicker
                    bootstrap=""
                    label="Desde"
                    type="date"
                    name="dateFrom"
                    onChange={handleSinceDateChange}
                    value={dateFrom}
                    disabled={membershipsDatatable.isLoading}
                  />
                  <FilterDatePicker
                    bootstrap=""
                    label="Hasta"
                    type="date"
                    name="dateTo"
                    onChange={handleUntilDateChange}
                    value={dateTo}
                    disabled={membershipsDatatable.isLoading}
                  />
                </div>
              )}

              <div className="filters-row__actions">
                {canSeePerPage && (
                  <SelectPerPage
                    label="Registros por página"
                    options={itemsPerpage}
                    value={membershipsDatatable.limit}
                    onChange={selectitemsPerpage}
                  />
                )}
                <ActionButton label="Limpiar Filtros" action={clearFilters} />
              </div>
            </div>
          </div>
        </div>

        <PotentialClientsTable
          header={particularClientsTableHeader(
            channels,
            {
              channels: handleChannelOptions,
              affiliated: handleAffiliatedOptions,
              serviceTypes: handleServiceTypeOptions,
            },
            serviceTypes
          )}
          data={membershipsDatatable}
          handlePageChange={handlePageChange}
          tableRef={tableRef}
          showEditableColumns={false}
        />
      </div>
    </>
  );
};
